import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Loading } from '@/kit';

/**
 * Bajo demanda: el import va al ARCHIVO y no al barrel `@/domains/credit`, que arrastraría las
 * demás pantallas al mismo chunk y anularía el split.
 */
const CustomerMessagesPage = lazy(() =>
    import('@/domains/credit/customerMessages/CustomerMessagesPage').then((m) => ({
        default: m.CustomerMessagesPage,
    })),
);

// El router puede coaccionar un id numérico: se acepta y se normaliza a texto.
// `.catch(undefined)` descarta el parámetro inválido en vez de tumbar la ruta.
const deepLinkParam = z
    .union([z.string(), z.number()])
    .transform(String)
    .optional()
    .catch(undefined);

const searchSchema = z.object({ p: deepLinkParam, plantilla: deepLinkParam });

export type CustomerMessagesSearch = z.infer<typeof searchSchema>;

/** Deep link: `?p=PM-034` o `?plantilla=PM-034` abre esa plantilla. Lo que no valida se ignora. */
export function parseCustomerMessagesSearch(
    search: Record<string, unknown>,
): CustomerMessagesSearch {
    const parsed = searchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
}

// Ruta estática: gana sobre la dinámica hermana `$section` (que sigue cubriendo el resto).
export const Route = createFileRoute('/_backoffice/credit/customer-messages')({
    validateSearch: parseCustomerMessagesSearch,
    component: CreditCustomerMessages,
});

function CreditCustomerMessages() {
    const { p, plantilla } = Route.useSearch();
    return (
        <Suspense fallback={<Loading fullScreen text="Cargando mensajes al cliente…" />}>
            <CustomerMessagesPage templateId={p ?? plantilla} />
        </Suspense>
    );
}
